import api from './api';
import { Team, ApiResponse } from '../types';

const teamService = {
  getAllTeams: async (page = 1, limit = 20): Promise<ApiResponse<Team[]>> => {
    try {
      const response = await api.get<ApiResponse<Team[]>>(`/teams?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getTeamsByLeague: async (leagueId: number): Promise<Team[]> => {
    try {
      const response = await api.get<Team[]>(`/teams/league/${leagueId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getPopularTeams: async (): Promise<Team[]> => {
    try {
      const response = await api.get<Team[]>('/teams/popular');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getTeamById: async (teamId: number): Promise<Team> => {
    try {
      const response = await api.get<Team>(`/teams/${teamId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  searchTeams: async (query: string): Promise<Team[]> => {
    try {
      const response = await api.get<Team[]>(`/teams/search?q=${encodeURIComponent(query)}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default teamService; 